window.addEventListener('load', (event) => {
  const classes = {
    filterToggle: '.cc-toolbar-filter-toggle',
    closeMenuButton: '.cc-product-filter__close',
    collectionContainer: '.collection-page',
    openMenuClass: 'cc-filters-mob-open',
    mobileVeilClass: '.page-category__mobile-veil'
  }
  const selectors = {
    container: document.querySelector(classes.collectionContainer)
  }
  const toggleSidebarMenu = (e) => {
    e.preventDefault();
    if (selectors.container.classList.contains(classes.openMenuClass)) {
      selectors.container.classList.remove(classes.openMenuClass);
      return false;
    }
    selectors.container.classList.add(classes.openMenuClass);
  }
  document.querySelector(classes.filterToggle).addEventListener('click', toggleSidebarMenu.bind(this));
  document.querySelector(classes.mobileVeilClass).addEventListener('click', toggleSidebarMenu.bind(this));
  document.querySelector(classes.closeMenuButton).addEventListener('click', toggleSidebarMenu.bind(this));
});